import { normalizeAppointmentResourceSelection } from "../appointmentResourceSelection";
import moment from "moment";

const FORM_DATE_FORMATS = ["dddd, DD MMMM YYYY", "YYYY-MM-DD"];

const parseFormDate = (value) => {
  if (!value) return null;
  const parsed = moment(value, FORM_DATE_FORMATS, true);
  return parsed.isValid() ? parsed : null;
};

export const buildAppointmentResourceAvailabilityRequest = (values = {}) => {
  const date = parseFormDate(values.dateof);
  const time = moment(values.start_time, ["HH:mm", "HH:mm:ss"], true);
  const start_datetime = date && time.isValid()
    ? `${date.format("YYYY-MM-DD")} ${time.format("HH:mm:ss")}`
    : values.start_datetime;

  return {
    ...normalizeAppointmentResourceSelection(values),
    ...(start_datetime ? { start_datetime } : {}),
  };
};
